<modal
    [id]="'impersonation-modal'"
    [modalType]="'modal-info'"
    [modalSize]="'small'"
    [title]="'impersonate'"
    [closeInClickOutside]="true"
    [visible]="isVisible()"
    (visibleChange)="hideModal()">
    <div body>
        @if (!userAlreadyImpersonated() && isVisible()) {
            <div class="form-group">
                <label [id]="'select-user-impersonate-label'">{{ 'impersonate.selectUser' | translate }}</label>

                <autocomplete-accounts
                    [id]="'select-user-impersonate-autocomplete'"
                    (select)="selectUser($event)"
                    (keyup.enter)="impersonate()"></autocomplete-accounts>
            </div>
        } @else {
            <div class="already-impersonated-container">
                <p class="title">{{ 'impersonate.alreadyExistingMessage1' | translate }}</p>
                <p class="message">{{ 'impersonate.alreadyExistingMessage2' | translate }}</p>

                <div class="impersonated-user">
                    <label>{{ 'impersonate.alreadyExistingMessage.user' | translate }}</label>
                    <p class="name">
                        {{ userAlreadyImpersonated()?.firstName }} {{ userAlreadyImpersonated()?.lastName }}
                    </p>
                    <p class="email">{{ userAlreadyImpersonated()?.email }}</p>
                </div>
            </div>
        }
    </div>

    <ng-container footer>
        @if (!userAlreadyImpersonated()) {
            <button-cancel [id]="'impersonation-modal-cancel'" (onClick)="hideModal()"></button-cancel>

            <ui-button
                [id]="'impersonation-modal-confirm'"
                [label]="'impersonate'"
                [severity]="'success'"
                [disabled]="selectedUser() === null"
                (onClick)="impersonate()"></ui-button>
        } @else {
            <ui-button
                [id]="'continue-as'"
                [label]="
                    ('impersonate.alreadyExistingMessage.continueAs' | translate) +
                    ' ' +
                    userAlreadyImpersonated()?.firstName
                "
                [severity]="'success'"
                (onClick)="syncTabs()"></ui-button>
        }
    </ng-container>
</modal>
